import { ProgressIndicator } from '@oneaudi/unified-web-components';
import React from 'react';
import styled from 'styled-components';

interface AppLoaderProps {
  fromFA: string;
  height?: boolean;
}

const LoaderContainer = styled.div<{ fromFA: string; height?: boolean }>`
  background-color: ${({ theme }) => theme.colors.colorCanvasDefault};
  ${({ theme }): string => (theme.type === 'alpha' ? 'border-radius: 20px;' : '')};
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: ${({ fromFA, height }): string => (fromFA === 'dealersearch' && height ? '72px' : '0')};
  width: 100%;
  margin: 12px 0;
  ${({ fromFA }): string => (fromFA === 'dealersearch' ? 'height: 50vh;' : '')};
  z-index: 5;
`;

const AudiSearchFeatureAppLoader: React.FC<AppLoaderProps> = ({ fromFA, height }) => {
  return (
    <LoaderContainer fromFA={fromFA} height={height}>
      <ProgressIndicator
        aria-label="Loading Indicator"
        data-testid="progress-indicator"
        size="lg"
        type="infinite"
        variant="spinner"
        colorScheme="colored"
      />
    </LoaderContainer>
  );
};

export default AudiSearchFeatureAppLoader;
